import { useParams } from 'react-router-dom';
import { isProjectSelection } from '@fe-learner-common/api/schemas/sessionsSchema';
import { CourseSelfRegDetails } from '@routes/selfreg/CourseSelfRegDetails';
import { ProjectSelectionSelfRegDetails } from '@routes/selfreg/ProjectSelectionSelfRegDetails';
import { useSelfregSessionDetails } from './hooks/data/useSelfregSessionDetails';

export const SelfRegRoute = () => {
  const { sessionId } = useParams();

  const { data: sessionDetails } = useSelfregSessionDetails({
    enabled: true,
    sessionId,
  });

  if (!sessionDetails) {
    return null;
  }

  return isProjectSelection(sessionDetails) ? (
    <ProjectSelectionSelfRegDetails sessionDetails={sessionDetails} />
  ) : (
    <CourseSelfRegDetails sessionDetails={sessionDetails} />
  );
};
